import { buildInitialState as buildInitialDateRangeState } from '@components/Kendo/DateRangePickerReducer';
import LinkTableCell from '@components/Kendo/LinkTableCell';
import { translate } from '@utils/i18n';
import VisitsCell from './nested/VisitsCell';
import ActionsCell from './nested/ActionsCell';
import StatusCell from './nested/StatusCell';

export const namespace = 'features.work_orders.index';

export const CACHE_KEY = 'kendo/work_orders/index_v2';

export const INITIAL_PAGE_SKIP = 0;

export const INITIAL_PAGE = { skip: INITIAL_PAGE_SKIP, take: 25 };

export const INITIAL_SORT = [
  {
    field: 'id',
    dir: 'desc'
  }
];

export const INITIAL_FILTERS = {
  values: {
    technicianTeam: '',
    technician: null,
    workOrderType: '',
    status: '',
    subcontractor: '',
    visitStatus: '',
    woNumber: '',
    tags: '',
    territory: '',
    additionalTerritory: '',
    building: '',
    buildingStatus: '',
    referenceNumber: '',
    account: '',
    ...buildInitialDateRangeState('visitDate'),
    ...buildInitialDateRangeState('dueDate')
  },
  active: {
    technicianTeam: false,
    technician: true,
    workOrderType: true,
    status: true,
    subcontractor: true,
    visitDate: true,
    dueDate: false,
    visitStatus: true,
    woNumber: true,
    tags: false,
    territory: true,
    additionalTerritory: false,
    building: true,
    account: false,
    buildingStatus: false,
    referenceNumber: false
  },
  operators: {
    woNumber: 'contains',
    referenceNumber: 'contains'
  }
};

export const DEFAULT_COLUMNS = [
  'woNumber',
  'referenceNumber',
  'status',
  'building',
  'visits',
  'visitWorkPerformed',
  'actions'
];

export const ALL_COLUMNS = [
  'woNumber',
  'referenceNumber',
  'status',
  'dueDate',
  'workOrderType',
  'building',
  'visits',
  'visitWorkPerformed',
  'actions'
];

export const ALL_COLUMNS_DATA = {
  selected: {
    id: 'selected',
    field: 'selected',
    sortable: false,
    title: translate('table.headers.selected', { namespace }),
    width: 64,
    className: 'k-table-td --selector',
    headerClassName: 'k-table-th --selector'
  },
  id: {
    id: 'id',
    field: 'id',
    width: 130,
    title: translate('table.headers.id', { namespace }),
    className: 'k-table-td --primary',
    headerClassName: 'k-table-th --primary',
    cell: LinkTableCell
  },
  woNumber: {
    id: 'woNumber',
    field: 'woNumber',
    width: 175,
    title: translate('table.headers.wo_no', { namespace })
  },
  referenceNumber: {
    id: 'referenceNumber',
    field: 'referenceNumber',
    width: 175,
    title: translate('table.headers.reference_number', { namespace })
  },
  status: {
    id: 'status',
    field: 'status',
    width: 200,
    title: translate('table.headers.status', { namespace }),
    cell: StatusCell
  },
  dueDate: {
    id: 'dueDate',
    field: 'dueDate',
    width: 175,
    title: translate('table.headers.due_date', { namespace })
  },
  workOrderType: {
    id: 'workOrderType',
    field: 'workOrderType',
    width: 175,
    title: translate('table.headers.wo_type', { namespace })
  },
  building: {
    id: 'building',
    field: 'building',
    width: 250,
    title: translate('table.headers.building', { namespace }),
    cell: LinkTableCell
  },
  visits: {
    id: 'visits',
    field: 'visits',
    width: 450,
    title: translate('table.headers.visits', { namespace }),
    sortable: false,
    cell: VisitsCell
  },
  visitWorkPerformed: {
    id: 'visitWorkPerformed',
    field: 'visitWorkPerformed',
    width: 300,
    title: translate('table.headers.visit_work_performed', { namespace }),
    sortable: false
  },
  actions: {
    id: 'actions',
    field: 'actions',
    width: 100,
    title: translate('table.headers.actions', { namespace }),
    sortable: false,
    cell: ActionsCell
  }
};
